<template>
  <div class="gf_apply-preset">
    <Modal
      classs
      c-class="gf_apply-preset-modal"
      h-class="bg-light1 p-0"
      m-class="gf_apply-preset-modal__body"
      @cancel="cancel">
      <template #header>
        <div class="d-flex align-items-center gf_apply-preset-modal__header">
          <h2 class="heading-20-medium txt-light-mode-high-contrast">Apply Preset to other Pages</h2>
          <div class="page-settings__btn" @click.prevent="cancel">
            <i class="icon icon-close" />
          </div>
        </div>
      </template>
      <template #default class="m-0">
        <div class="gf_apply-preset-modal__body__content">
          <div class="gf_apply-preset-modal__body__content__search">
            <InputSearch
              v-model="query"
              sclass="gf_apply-preset-modal__body__content__search__input"
              :searching="seaching"
              placeholder="Search page"
              clear />
          </div>
          <div class="gf_apply-preset-modal__body__content__table">
            <div class="gf_apply-preset-modal__body__content__table__header">
              <div class="gf_apply-preset-modal__body__content__table__header-left">
                <label class="gf_checkbox">
                  <span v-if="selectedItems.length > 0">Selected {{ selectedItems.length }} pages</span>
                  <input
                    class="gf_checkbox__input"
                    :checked="selectedItems.length > 0"
                    type="checkbox"
                    @change="toggleSelectedPage()" />
                  <span class="gf_checkbox__checkmark">
                    <i class="icon icon-rectangle gf_checkbox__checkmark--icon" />
                  </span>
                </label>
              </div>

              <div class="gf_apply-preset-modal__body__content__table__header-right">
                <div class="gf_apply-preset-modal__body__content__table__header-right__box paragraph-12-medium">
                  {{ selectedPreset.name }}
                  <GfDropdown
                    :options="presetOptions"
                    f-type="simple"
                    value=""
                    dropdown-class="gf_apply-preset-modal__body__content__table__header-option_dropdown"
                    b-class="paragraph-12-medium"
                    dropdown-item-class="gf_apply-preset-modal__body__content__table__header-option_dropdown-item"
                    @selected="presetFilter">
                  </GfDropdown>
                </div>
                <div class="gf_apply-preset-modal__body__content__table__header-right__box paragraph-12-medium">
                  {{ pageType.name }}
                  <GfDropdown
                    :options="pageTypes"
                    f-type="simple"
                    value=""
                    dropdown-class="gf_apply-preset-modal__body__content__table__header-option_dropdown"
                    b-class="paragraph-12-medium"
                    dropdown-item-class="gf_apply-preset-modal__body__content__table__header-option_dropdown-item"
                    @selected="pageTypeFilter">
                  </GfDropdown>
                </div>
                <div class="gf_apply-preset-modal__body__content__table__header-right__box paragraph-12-medium">
                  {{ sortOption.name }}
                  <GfDropdown
                    :options="optionSorts"
                    :visible-name="false"
                    f-type="simple"
                    value="createdAt"
                    dropdown-class="gf_apply-preset-modal__body__content__table__header-option_dropdown"
                    b-class="paragraph-12-medium"
                    dropdown-item-class="gf_apply-preset-modal__body__content__table__header-option_dropdown-item"
                    @selected="sortAction">
                  </GfDropdown>
                </div>
              </div>
            </div>
            <div class="gf_apply-preset-modal__body__content__table__body">
              <div class="gf_apply-preset-modal__body__list">
                <div class="gf_apply-preset-modal__body__list-scroll">
                  <perfect-scrollbar class="gf_apply-preset-modal__body__scroll">
                    <div v-if="typeSeaching" class="gf_apply-preset-modal__body__loading">
                      <img class="snack-loading" src="@/assets/icons/loading.svg" alt="" />
                    </div>
                    <div
                      v-for="(item, index) in listPages"
                      :key="index"
                      class="gf_apply-preset-modal__body__scroll__item"
                      @click="selectItem(item)">
                      <div class="gf_apply-preset-modal__body__scroll__item--checkbox">
                        <Checkbox :checked="selectedIds" :value="item.g_id" :locked="true" :size="14" />
                      </div>
                      <div class="gf_apply-preset-modal__body__scroll__item--name paragraph-12-medium">
                        <span>{{ item.g_title }}</span>
                        <span v-if="mappedPresets[item.preset_id]" class="gf_linked-preset-name">{{
                          mappedPresets[item.preset_id]
                        }}</span>
                      </div>
                      <button
                        class="gf_apply-preset-modal__body__scroll__item--action paragraph-12-medium"
                        @click.stop="opentPreview(item.g_id)">
                        Preview Preset
                      </button>
                    </div>
                    <div v-if="!listPages.length" class="gf_apply-preset-modal__body__no-result">
                      <div class="gf_apply-preset-modal__body__no-result_title">No results for "{{ query }}"</div>
                      <div class="gf_apply-preset-modal__body__no-result_subtitle">
                        Please try again for different keywords
                      </div>
                    </div>
                  </perfect-scrollbar>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gf_apply-preset-modal__body__footer">
          <button
            class="gf_apply-preset-modal__body__footer__action"
            :class="{ 'gf_action--disabled': selectedItems.length <= 0 }"
            :disabled="selectedItems.length <= 0"
            @click="applyPageSelect()">
            <template v-if="selectedItems.length == 0">Select page(s) to apply</template>
            <template v-else>Apply Preset to {{ selectedItems.length }} pages</template>
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import InputSearch from '@/core/components/form/InputSearch.vue';
import { actions } from '@modules/editor-sidebar';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ApplyPresetModal',
  components: {
    InputSearch,
  },
  props: {
    propName: {
      type: Number,
      default: 1,
    },
    querySearch: String,
  },
  data() {
    return {
      selectedItems: [],
      presetOptions: [
        {
          name: 'All Presets',
          value: '',
        },
        {
          name: 'None',
          value: 0,
        },
      ],
      pageTypes: [
        {
          name: 'All Pages',
          value: '',
        },
        {
          name: 'Landing Pages',
          value: 'template-page',
        },
        {
          name: 'Home Pages',
          value: 'template-index',
        },
        {
          name: 'Product Pages',
          value: 'template-product',
        },
        {
          name: 'Collection Pages',
          value: 'template-collection',
        },
        {
          name: 'Blog Posts',
          value: 'template-article',
        },
      ],
      optionSorts: [
        {
          name: 'Last Created',
          value: 'createdAt',
        },
        {
          name: 'Last Modified',
          value: 'updatedAt',
        },
        {
          name: 'Name (A-Z)',
          value: 'name',
        },
      ],
      mappedPresets: {},
      val: false,
      value: true,
      query: '',
      searchTimeOut: null,
      seaching: false,
      typeSeaching: false,
      selectedPreset: {
        name: 'All Presets',
        value: '',
      },
      pageType: {
        name: 'All Pages',
        value: '',
      },
      sortOption: {
        name: 'Last Created',
        value: 'createdAt',
      },
    };
  },
  computed: {
    ...mapState('sidebar', {
      listPages: 'pages',
      listPresets: 'presets',
    }),
    selectedIds() {
      return this.selectedItems.map((x) => {
        return x.g_id;
      });
    },
  },
  watch: {
    query(_) {
      clearTimeout(this.searchTimeOut);

      this.searchTimeOut = setTimeout(() => {
        this.searchPage();
      }, 500);
    },
  },
  created() {
    this.initPresetOptions();
    this.searchPage();
  },
  methods: {
    ...mapActions('sidebar', {
      fetchPages: actions.FETCH_PAGES,
    }),
    initPresetOptions() {
      for (const preset of this.listPresets) {
        this.mappedPresets[preset.id] = preset.name;

        this.presetOptions.push({
          name: preset.name,
          value: preset.id,
        });
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    opentPreview(id) {
      alert(id);
    },
    selectItem(item) {
      const idx = this.selectedItems.findIndex((x) => x.g_id == item.g_id);
      if (idx > -1) {
        this.selectedItems.splice(idx, 1);
        return;
      }
      this.selectedItems.push(item);
    },
    toggleSelectedPage() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.listPages.slice();
      }
    },
    async searchPage(loading = 'seaching') {
      this[loading] = true;
      await this.fetchPages({
        gType: this.pageType.value,
        order: this.sortOption.value,
        presetId: this.selectedPreset.value,
        q: this.query,
      });
      this[loading] = false;
    },
    pageTypeFilter(data) {
      this.pageType = data;
      this.searchPage('typeSeaching');
      return;
    },
    presetFilter(data) {
      this.selectedPreset = data;
      this.searchPage('typeSeaching');
      return;
    },
    sortAction(data) {
      this.sortOption = data;
      this.searchPage('typeSeaching');
      return;
    },
    applyPageSelect() {
      this.$emit('applyPageSelect', this.selectedItems);
    },
  },
};
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
$screen-md: 848px;
$height-scroll: calc(50vh - 0px);

.gf_apply-preset-modal {
  width: 68vw;
  max-width: $screen-md;

  &__header {
    padding: 20px 32px;
    justify-content: space-between;
  }
  &__body {
    margin: 16px;
    max-width: 100%;
    height: 100%;
    background: map-get($hybrid-shade-light, '100');

    &__no-result {
      position: absolute;
      right: 50%;
      top: 50%;
      transform: translate(50%, 0);
      text-align: center;

      &_title {
        font-weight: 600;
        font-size: 16px;
        line-height: 150%;
        color: #212121;
        margin-bottom: 8px;
      }

      &_subtitle {
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        color: #676767;
      }
    }

    &__loading {
      padding: 21px;
      text-align: center;

      .snack-loading {
        width: 21px;
        animation: spin 1s linear infinite;
      }
    }

    &__content {
      &__search {
        padding: 16px;
        padding-bottom: 0;
        &__input {
          height: 40px;
          padding: 8px 16px;
          &.focusing {
            .input-search-finder {
              color: map-get($text-light-mode, 'high-contrast') !important;
            }
          }
          .input-search-finder {
            color: map-get($text-light-mode, 'high-contrast') !important;
          }
          .gf_input-search {
            border: 0 !important;
            padding: 8px !important;
            padding-left: 24px !important;
            &::placeholder {
              color: map-get($text-light-mode, 'disabled');
            }
          }
        }
      }
      &__table {
        &__header {
          @include flex-align-center;
          justify-content: space-between;
          border-top: 1px solid map-get($hybrid-shade-light, '500');
          border-bottom: 1px solid map-get($hybrid-shade-light, '500');
          margin: 8px 16px 0px 16px;
          &-right {
            @include flex-align-center;
            &__box {
              @include flex-align-center;
              color: map-get($text-light-mode, 'high-contrast');
              margin-left: 16px !important;
            }
          }
          &-left {
            margin-left: 1px;
          }
          &-option_dropdown {
            .gf_btn--dropdown {
              background-color: transparent !important;
              border: 0;
              width: max-content;
              padding: 0;
              margin-left: 4px;
              .gf_dropdown {
                &__label {
                  font-family: 'Inter';
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 14px;
                  color: map-get($text-light-mode, 'high-contrast') !important;
                }
                &__svg {
                  font-family: 'Inter';
                  width: 16px;
                  height: 16px;
                  @include flex-center;
                  margin-left: 4px;
                  path {
                    fill: map-get($text-light-mode, 'high-contrast') !important;
                  }
                }
              }
            }
            .simple.gf_dropdown--options {
              z-index: 2;
              background: map-get($hybrid-shade-light, '100') !important;
              width: 151px;
            }
          }
        }
      }
    }
    &__list-scroll {
      height: $height-scroll;
      max-height: $height-scroll;
    }
    &__scroll {
      height: 100%;
      padding: 0px 16px 0 16px;
      &__item {
        @include flex-align-center;
        flex-wrap: nowrap;
        flex: 1;
        padding: 13px 0;
        border-top: 1px solid map-get($hybrid-shade-light, '500');
        &:first-child {
          border-top: 0;
        }
        &--checkbox {
          width: 14px;
          margin-right: 8px;
          margin-left: 1px;
          cursor: pointer;
          &:hover {
            background-color: map-get($hybrid-shade-light, '500');
            border-radius: 3px;
          }
          .checkbox {
            pointer-events: none;
            cursor: pointer;
            border: 1px solid map-get($hybrid-shade-dark, '100');
            .icon-check {
              font-size: 8px !important;
            }
          }
        }
        &--name {
          flex-basis: 0;
          flex-grow: 1;
          max-width: 100%;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: map-get($text-light-mode, 'high-contrast');
          margin-right: 8px;
          cursor: pointer;
        }
        &--action {
          font-family: 'Inter';
          padding: 5px 8px;
          background: map-get($hybrid-shade-light, '300');
          border: 0;
          border-radius: 3px;
          color: map-get($text-light-mode, 'high-contrast');
          min-width: 102px;
          min-height: 24px;
          &:hover {
            background: map-get($text-dark-mode, 'high-contrast');
          }
        }
      }
    }
    &__footer {
      padding: 16px;
      &__action {
        width: 100%;
        border: 0;
        border-radius: 3px;
        font-family: 'Inter';
        background: map-get($primary-blue-ui-kit, '300');
        color: map-get($hybrid-shade-light, '100');
        padding: 12px;
        &:hover {
          background: map-get($primary-blue-ui-kit, '325');
        }
        &.gf_action--disabled {
          background: map-get($hybrid-shade-light, '500');
          color: map-get($text-light-mode, 'disabled');
          cursor: unset;
        }
      }
    }
  }
  .gf_checkbox {
    @include flex-align-center;
    position: relative;
    padding-left: 24px;
    cursor: pointer;
    user-select: none;
    color: map-get($text-light-mode, 'high-contrast');
    padding-bottom: 0;
    &__input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
      &:checked ~ .gf_checkbox__checkmark {
        border: 1px solid map-get($primary-blue-ui-kit, '300');
        background-color: map-get($primary-blue-ui-kit, '300');
      }
      &:checked ~ .gf_checkbox__checkmark::after {
        display: block;
      }
    }

    &__checkmark {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      height: 14px;
      width: 14px;
      border: 1px solid map-get($hybrid-shade-dark, '100');
      border-radius: 3px;
      margin: 1px;
      &:hover {
        background-color: map-get($hybrid-shade-light, '500');
      }
      &::after {
        content: '';
        position: absolute;
        display: none;
        left: 50%;
        top: 50%;
        border: 1px solid map-get($hybrid-shade-light, '100');
        width: 7px;
        transform: translate(-50%, -50%);
      }
    }
  }
}

.gf_linked-preset-name {
  background: #d8e1ff;
  border-radius: 3px;
  color: #0a3be7;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  padding: 1px 4px;
  margin-left: 8px;
}
</style>
